<template>
  <el-container class="doc" direction='vertical'>
    <div class="search-container">
      <div class="v-refresh" @click="refresh">刷新</div>
      <div class="v-text">店铺总余额：<span>{{statisticsInfo.balance_all}}</span></div>
      <div class="v-text">已转入余额：<span>{{statisticsInfo.transfered}}</span></div>
      <div class="v-text">未转入余额：<span>{{statisticsInfo.untransfered}}</span></div>
      <!-- <el-button type="danger">导出本表</el-button> -->
    </div>
    <div class="search-container">
      <div class="v-search-btn">
        <el-date-picker value-format="yyyy-MM-dd" class="v-date" v-model="valuedate" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
        </el-date-picker>
        <el-button type="primary" icon="el-icon-search" @click="clickSearch" size="medium">查询</el-button>
      </div>
    </div>
    <el-container direction='vertical' class="mian-container">
      <div class="scrollbar-container">
        <el-scrollbar>
          <el-table :data="tableData" stripe highlight-current-row>
            <el-table-column align="center" label="数据类型">
              <template slot-scope="scope">
                <span>{{ scope.row.dataType }} </span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="金额（元）">
              <template slot-scope="scope">
                <span>{{ scope.row.amount }} </span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="其他金额（元）">
              <template slot-scope="scope">
                <span>{{ scope.row.otherAmount }} </span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="操作">
              <template slot-scope="scope">
                <el-button v-if="scope.row.type !== 'account'" size="mini">
                  <span @click="clickExport(scope.row)">导出详情</span>
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="remark-container">
            <div class="v-remark">店铺总余额 = 充值总额 + 转入总额 + 未转入总额 - 消费总额</div>
            <div class="v-remark">充值总计 = 在线充值 + 现金充值 + 刷卡充值 + 其他充值 </div>
            <div class="v-remark">消费总计 = 余额支付 + 后台扣款 </div>
          </div>
        </el-scrollbar>
      </div>
    </el-container>
  </el-container>
</template>
<script>
import {
  statisticsBalance,
  statisticsRecords
} from '@/views/webpc/CashierDesk/CheckingApp/apis'
export default {
  data () {
    return {
      isLoading: false,
      tableData: [],
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      },
      valuedate: null,
      statisticsInfo: {}
    }
  },
  methods: {
    loadData () {
      this.isLoading = true
      this.tableData = []
      let data = new FormData()
      if (this.valuedate) {
        data.append('startdate', this.valuedate[0])
        data.append('enddate', this.valuedate[1])
      }
      statisticsRecords(data)
        .then((result) => {
          if (result) {
            this.isLoading = false
            let res = result.data
            this.tableData = [
              {
                dataType: '充值总计',
                amount: res.recharge_total,
                otherAmount: '0',
                num: '',
                type: 'recharge'
              },
              {
                dataType: '在线充值',
                amount: res.recharge0_total,
                otherAmount: '0',
                num: '0',
                type: 'recharge'
              },
              {
                dataType: '现金充值',
                amount: res.recharge1_total,
                otherAmount: '0',
                num: '1',
                type: 'recharge'
              },
              {
                dataType: '刷卡充值',
                amount: res.recharge2_total,
                otherAmount: '0',
                num: '2',
                type: 'recharge'
              },
              {
                dataType: '其他充值',
                amount: res.recharge3_total,
                otherAmount: '0',
                num: '3',
                type: 'recharge'
              },
              {
                dataType: '消费总计',
                amount: res.spend_total,
                otherAmount: '0',
                num: '',
                type: 'spend'
              },
              {
                dataType: '余额支付',
                amount: res.spend0_total,
                otherAmount: '0',
                num: '0',
                type: 'spend'
              },
              {
                dataType: '后台扣款',
                amount: res.spend1_total,
                otherAmount: '0',
                num: '1',
                type: 'spend'
              },
              {
                dataType: '可到账金额',
                amount: (res.recharge0_total * (1 - 0.006)).toFixed(2),
                otherAmount: '0',
                num: '1',
                type: 'account'
              },
              {
                dataType: `店铺余额（${res.balanceMoment}）`,
                amount: res.balance,
                otherAmount: '0',
                num: '1',
                type: 'account'
              }
            ]
          }
        })
        .catch((error) => {
          if (error) {
            this.isLoading = false
          }
        })
    },
    // 分页
    currentChange (val) {
      this.page = val
      this.loadData()
    },
    clickSearch () {
      this.page = 1
      this.loadData()
    },
    // 刷新
    refresh () {
      this.loadData()
      this.getStatisticsBalance()
    },
    // 消费统计
    getStatisticsBalance () {
      statisticsBalance().then((result) => {
        if (result) {
          this.statisticsInfo = result.data
        }
      })
    },
    // 导出
    clickExport (res) {
      let startdate = ''
      let enddate = ''
      if (this.valuedate && this.valuedate.length !== 0) {
        startdate = this.valuedate[0]
        enddate = this.valuedate[1]
      }
      if (res.type === 'recharge') {
        window.open(
          'api/Admin/Record/exportRechargeList?startdate=' +
            startdate +
            '&enddate=' +
            enddate +
            '&rechargetype=' +
            res.num
        )
      } else {
        window.open(
          '/api/Admin/Record/exportSpendList?startdate=' +
            startdate +
            '&enddate=' +
            enddate +
            '&spendtype=' +
            res.num
        )
      }
    }
  },
  mounted () {
    this.loadData()
    this.getStatisticsBalance()
  }
}
</script>



// WEBPACK FOOTER //
// src/views/webpc/CashierDesk/CheckingApp/Checking.vue